import React from 'react';

const AvailableTournaments = ({ tournamentSlots }) => {
  // Check if user has selected both prediction and TPC
  const hasValidSelection = tournamentSlots && tournamentSlots.every(slot => slot.value !== null);
  const selectedPrediction = tournamentSlots ? tournamentSlots.find(slot => slot.placeholder === "Prediction")?.value : null;
  const selectedTPC = tournamentSlots ? tournamentSlots.find(slot => slot.placeholder === "TPC Wager")?.value : null;

  // Mock available matches based on selection
  const mockMatches = hasValidSelection ? [
    {
      id: 1,
      tournament: "US Open Golf Championship",
      match: "Longest Drive",
      prizePool: 500,
      participants: 8,
      minWager: 10,
      deadline: "2 days"
    },
    {
      id: 2,
      tournament: "US Open Golf Championship", 
      match: "Hole-in-One",
      prizePool: 250,
      participants: 4,
      minWager: 5,
      deadline: "2 days"
    }
  ] : [];

  const getComponent = () => {
    if (!selectedPrediction) {
      return <p className="card-details__craft-empty">Select a prediction</p>;
    }
    
    if (!selectedTPC) {
      return <p className="card-details__craft-empty">Select a TPC wager</p>;
    }

    if (mockMatches.length === 0) {
      return <p className="card-details__craft-empty">No available matches</p>;
    }

    return (
      <div className="card-details__craft-list-wrapper">
        <ul className="card-details__craft-list">
          {mockMatches.map((match) => (
            <li className="card-details__craft-item" key={match.id}>
              <button className="card-details__craft-item-button card-details__craft-item-button--eligibles">
                <div>
                  <strong>{match.tournament}</strong>
                  <div>Match: {match.match}</div>
                  <div>Prize Pool: ${match.prizePool}</div>
                  <div>Participants: {match.participants}</div>
                  <div>Min Wager: ${match.minWager}</div>
                  <div>Deadline: {match.deadline}</div>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <section className="card-details__card card-details__card--craft-info">
      <h3 className="card-details__title">Available Matches</h3>
      {getComponent()}
    </section>
  );
};

export default AvailableTournaments;
